// eslint-disable-next-line import/no-anonymous-default-export
export default 'v1.2.12';
